import PanelAdminSection from './PanelAdminSection';
import CoachAdviseesPanel from '../coach/CoachAdviseesPanel';
import { openTrainingModule } from '../../utils/trainingModule';

/** Panel del entrenador: hub coach-first (Seguimiento → Clientes → IA → Planes → Galería → Estadísticas → Finanzas). */
const COACH_CARDS = [
  { id: 'progress', view: 'progress' },
  { id: 'adminusers', view: 'adminusers' },
  { id: 'coachai', view: 'coachai' },
  { id: 'admintraining', view: 'admintraining' },
  { id: 'admingallery', view: 'admingallery' },
  { id: 'training-stats', view: 'training-stats' },
  {
    id: 'finance-training',
    view: 'finance-training',
    when: (has) => has(['entrenador', 'nutricionista', 'admin_training', 'admin_entrenador', 'super_admin']),
  },
];

/** Admin de entrenadores (operaciones): coaches + usuarios vinculados. */
const OPS_CARDS = [
  { id: 'admintrainers', view: 'admintrainers' },
  { id: 'adminusers', view: 'adminusers' },
  { id: 'progress', view: 'progress' },
  { id: 'training-stats', view: 'training-stats' },
  {
    id: 'finance-training',
    view: 'finance-training',
    when: (has) => has(['super_admin', 'admin_training', 'admin_entrenador']),
  },
];

export default function TrainersAdminView({
  hasAnyRole,
  onNavigate,
  onBack,
  trainingExternal,
  trainingExternalUrl,
  useShellCoachPanel = false,
  variant = 'coach',
}) {
  if (useShellCoachPanel && variant === 'coach') {
    return (
      <CoachAdviseesPanel onBack={onBack} onNavigate={onNavigate} />
    );
  }

  if (trainingExternal) {
    return (
      <div className="dashboard-main-view p-6 max-w-xl">
        <button type="button" className="text-sm text-stone-600 mb-4 hover:underline" onClick={onBack}>
          ← Volver
        </button>
        <h3 className="text-xl font-bold text-stone-900 mb-2">Módulo Entrenadores</h3>
        <p className="text-stone-600 mb-4">
          Opera en el módulo embebido (<code className="text-xs">/training-module</code>), igual que FOOD_PLAN.
        </p>
        <button type="button" className="btn-primary" onClick={() => openTrainingModule('/dashboard', '/coach')}>
          Abrir módulo Entrenadores
        </button>
      </div>
    );
  }

  const cards = variant === 'ops' ? OPS_CARDS : COACH_CARDS;
  const backLabelKey = variant === 'ops' ? 'panel.back_services' : 'panel.back_panel';

  return (
    <PanelAdminSection
      panelId="training"
      onBack={onBack}
      backLabelKey={backLabelKey}
      hasAnyRole={hasAnyRole}
      onNavigate={onNavigate}
      cards={cards}
    />
  );
}
